import { Controller } from "../../../Controller";
import {
    FinalizarReservaProdutoService,
    ListarProdutosReservadosService,
} from "../../../../Services/Vendas/Produtos/GestaoReservas/GestaoReservasServices";

export async function ListarProdutosReservadosController(page: number) {
    return Controller(ListarProdutosReservadosService(page));
}

export async function FinalizarReservaProdutoController(idProduto: number) {
    return Controller(FinalizarReservaProdutoService(idProduto));
}
